import { render, staticRenderFns } from "./ListNijmegen.vue?vue&type=template&id=25940348&"
import script from "./ListNijmegen.vue?vue&type=script&lang=js&"
export * from "./ListNijmegen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports